/**
 * Stripe Tax settings for subscription catalog Prices (admin create flow).
 * Keep in sync with backend/app/services/tax-context.service.js
 */

export const DEFAULT_TAX_CODE = "txcd_10000000";

/** @see backend category.model.js — Subscriptions / advertising */
export const SUBSCRIPTION_ADVERTISEMENT_TAX_CODE = "txcd_20030000";

export const SUBSCRIPTION_CATALOG_TAX_BEHAVIOR = "exclusive";

export function getAdvertisementSubscriptionTaxCode() {
  const envOverride = process.env.REACT_APP_STRIPE_ADVERTISEMENT_TAX_CODE;
  if (envOverride && String(envOverride).trim()) {
    return String(envOverride).trim();
  }
  if (SUBSCRIPTION_ADVERTISEMENT_TAX_CODE) {
    return SUBSCRIPTION_ADVERTISEMENT_TAX_CODE;
  }
  return DEFAULT_TAX_CODE;
}

export function getSubscriptionCatalogPriceTaxSettings() {
  return {
    tax_behavior: SUBSCRIPTION_CATALOG_TAX_BEHAVIOR,
  };
}

export function getSubscriptionCatalogProductTaxCode(planType) {
  const isAdvertisement =
    planType && String(planType).trim().toLowerCase() === "advertisement";
  return isAdvertisement
    ? getAdvertisementSubscriptionTaxCode()
    : DEFAULT_TAX_CODE;
}

/** For logging only — do not pass tax_code to Price APIs. */
export function getSubscriptionCatalogTaxSettings(planType) {
  return {
    ...getSubscriptionCatalogPriceTaxSettings(),
    tax_code: getSubscriptionCatalogProductTaxCode(planType),
  };
}
